// 价格，小数点后四位
const price = {
  reg: /^([0](\.\d{1,4}))$|^([1-9][0-9]*(\.\d{1,4})?)$/,
  message: '需大于0，小数点后最长四位'
}
// 余额支付申请，小数点后四位
const priceYue = {
  reg: /^([0-9]+[\d]*(.[0-9]{1,2})?)$/,
  message: '小数点后最长两位'
}
// 其他价格, 小数点后四位
const elsePrice = {
  reg: /^([0-9]+[\d]*(.[0-9]{1,4})?)$/,
  message: '需大于等于0，小数点后最长四位'
}

// 出血，大于等于0 小数点后两位
const hemorrhage = {
  reg: /^([0-9]+[\d]*(.[0-9]{1,2})?)$/,
  message: '需大于等于0，小数点后最长两位'
}

// 合成区规格，小数点后两位
const area = {
  reg: /^([0-9]+[\d]*(.[0-9]{1,2})?)$/,
  message: '小数点后最长两位'
}

// 产品名称， 部分特殊字符
const name = {
  reg: "[`~!@#$^&*()=|{}':;',\\[\\]<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]",
  message: '请勿使用特殊字符'
}

// sku名称， 部分特殊字符
const skuName = {
  reg: /[/\\<>?:*"|]/,
  message: '不能输入/\\<>?:*"|'
}

const checkInteger = {
  reg: /^[1-9]d*|0$/,
  message: '仅可输入非负整数'
}

export default {
  price,
  priceYue,
  elsePrice,
  hemorrhage,
  area,
  name,
  skuName,
  checkInteger
}
